import React, { useState, Fragment } from 'react';
import Text from '../../../../components/Typography/Text';
import Link from '../../../../components/Typography/Link';
import Checkbox from '../../../../components/Misc/Checkbox';
import { useAccountContext } from '../Data/accountContext';
import { saveClientDisclosure } from '../../../../services/DisclosureService';
import CustomerAccountAgreementModal from '../../../../components/Modals/CustomerAccountAgreementModal';
import DisclosureByIdModal from '../../../../components/Modals/DisclosureByIdModal';
import MarginAgreementModal from '../../../../components/Modals/MarginAgreementModal';
import MarginDisclosureModal from '../../../../components/Modals/MarginDisclosureModal';
import { saveRegistrationDisclosure } from '../../../../services/RegistrationService';
import FormBase from '../FormBase';

import { validateDisclosures, hasError } from '../Data/validation';

export default function FormDisclosures() {
  const { account, setAccount, dynamicDisclosures, setDynamicDisclosures, viewOnly } =
    useAccountContext();
  const [disclosureId, setDisclosureId] = useState([]);
  const [disclosureTitle, setDisclosureTitle] = useState([]);
  const [disclosureIndex, setDisclosureIndex] = useState(null);
  const [open, setOpen] = React.useState({
    marginAgreementModal: false,
    marginDisclosureModal: false,
    customerAgreementModal: false,
    DisclosureByIdModal: false,
  });

  const [validation, setValidation] = React.useState({});

  const handleSaveDisclosure = async (copy) => {
    let disclosureArray = [];

    for (let i = 0; i < copy.length; i++) {
      const disclosure = copy[i];
      if (disclosure.checked) {
        disclosureArray.push(disclosure.disclosureId);
      }
    }

    if (disclosureArray.length > 0) {
      await saveClientDisclosure(disclosureArray);
    }
  };

  const handleCloseModal = async (acceptedValue) => {
    setOpen({
      marginAgreementModal: false,
      customerAgreementModal: false,
      DisclosureByIdModal: false,
    });

    if (acceptedValue === 'agreement accepted') {
      await saveRegistrationDisclosure('Customer Agreement', true);
      setAccount({ ...account, customerAccountAgreement: true });
    }
    if (acceptedValue === 'disclosure accepted') {
      await saveRegistrationDisclosure('Margin Disclosure', true);
      setAccount({ ...account, marginDisclosure: true });
    }
    if (acceptedValue === 'margin agreement accepted') {
      await saveRegistrationDisclosure('Margin Agreement', true);
      setAccount({ ...account, marginAgreement: true });
    }
  };

  const handleCloseDynamicModal = (index) => {
    setOpen({
      DisclosureByIdModal: false,
    });

    const copy = [...dynamicDisclosures];
    copy[index].checked = true;
    setDynamicDisclosures(copy);
    handleSaveDisclosure(copy);
  };

  const handleSave = async () => {
    let errs = validateDisclosures(account, dynamicDisclosures);

    setValidation(errs);
    if (hasError(errs)) {
      console.log('disclosure errs', errs);
      return { acct: account, err: true };
    }

    return { acct: account, err: false };
  };

  return (
    <FormBase
      name="disclosures"
      header="Disclosures"
      subHeader=""
      faq="Disclosures"
      save={handleSave}
    >
      <div>
        {account.marginType === 'Margin' && (
          <>
            <div className="grd-row">
              <div className="col">
                {!!validation?.marginAgreement && (
                  <div className="grd-row">
                    <Text
                      ml={10}
                      error={!!validation?.marginAgreement}
                      label="Please check Margin Agreement"
                      variant="subtitle1"
                    />
                  </div>
                )}
                <Checkbox
                  mt={11}
                  ml={0}
                  required={true}
                  labelLink={true}
                  name="readMarginAgreement"
                  label={
                    <React.Fragment>
                      I have read and accepted the
                      <span
                        onClick={(e) => {
                          setOpen({ ...open, marginAgreementModal: true });
                          e.preventDefault();
                        }}
                      >
                        <Link ml={5} label="Margin Agreement" />.
                      </span>
                    </React.Fragment>
                  }
                  checked={account.marginAgreement}
                  disabled={true}
                />
              </div>
            </div>
            <div className="grd-row">
              <div className="col">
                {!!validation?.marginDisclosure && (
                  <Text
                    mt={10}
                    ml={10}
                    error={!!validation?.marginDisclosure}
                    label="Please check Margin Disclosure Statement"
                    variant="subtitle1"
                  />
                )}
                <Checkbox
                  mt={11}
                  ml={0}
                  required={true}
                  labelLink={true}
                  name="marginDisclosure"
                  label={
                    <React.Fragment>
                      I have read and accepted the
                      <span
                        onClick={(e) => {
                          setOpen({ ...open, marginDisclosureModal: true });
                          e.preventDefault();
                        }}
                      >
                        <Link ml={5} label="Margin Disclosure Statement" />.
                      </span>
                    </React.Fragment>
                  }
                  checked={account.marginDisclosure}
                  disabled={true}
                />
              </div>
            </div>
          </>
        )}
        <div className="grd-row">
          <div className="col">
            {!!validation?.customerAccountAgreement && (
              <Text
                mt={10}
                ml={10}
                error={!!validation?.customerAccountAgreement}
                label="Please check Customer Account Agreement"
                variant="subtitle1"
              />
            )}
            <Checkbox
              mt={11}
              ml={0}
              required={true}
              disabled={true}
              labelLink={true}
              name="customerAccountAgreement"
              label={
                <React.Fragment>
                  I have read and accepted the
                  <span
                    onClick={(e) => {
                      setOpen({
                        ...open,
                        customerAgreementModal: true,
                      });
                      e.preventDefault();
                    }}
                  >
                    <Link ml={5} label="Customer Account Agreement" />.
                  </span>
                </React.Fragment>
              }
              checked={account.customerAccountAgreement}
            />
          </div>
        </div>
        {dynamicDisclosures?.map((disclosure, index) => (
          <div key={index}>
            <div className="grd-row">
              <div className="col">
                {!!validation['dynamic' + index] && (
                  <Text
                    mt={10}
                    ml={10}
                    error={!!validation?.customerAccountAgreement}
                    label={validation['dynamic' + index]}
                    variant="subtitle1"
                    color="red"
                  />
                )}
                <Checkbox
                  disabled
                  error={!!validation['dynamic' + index]}
                  msg={validation['dynamic' + index]}
                  mt={11}
                  ml={0}
                  required={true}
                  labelLink={true}
                  name={'read ' + disclosure.title}
                  label={
                    <Fragment>
                      I have read and accepted the{' '}
                      <span
                        onClick={(e) => {
                          setOpen({ ...open, DisclosureByIdModal: true });
                          e.preventDefault();
                          setDisclosureId(disclosure.disclosureId);
                          setDisclosureTitle(disclosure.title);
                          setDisclosureIndex(index);
                        }}
                      >
                        <Link ml={5} label={disclosure.title} />.
                      </span>
                    </Fragment>
                  }
                  checked={disclosure.checked}
                  onChange={(e) => {
                    const copy = [...dynamicDisclosures];
                    copy[index].checked = e.currentTarget.checked;
                    setDynamicDisclosures(copy);
                    handleSaveDisclosure(copy);
                  }}
                />
              </div>
            </div>
          </div>
        ))}

        <Text
          mt={50}
          mb={12}
          label={
            <Fragment>
              <b>Disclosures Agreement: </b>
              <span>
                By accepting this document, I acknowledge that I have read and understood
                each disclosure's terms and conditions.
              </span>
            </Fragment>
          }
        />
        {open.customerAgreementModal && (
          <CustomerAccountAgreementModal
            accountData={account}
            open={open.customerAgreementModal}
            onClose={handleCloseModal}
          />
        )}
        {open.DisclosureByIdModal && (
          <DisclosureByIdModal
            disabled={viewOnly}
            open={open.DisclosureByIdModal}
            close={handleCloseModal}
            disclosureId={disclosureId}
            disclosureTitle={disclosureTitle}
            accept={() => handleCloseDynamicModal(disclosureIndex)}
          />
        )}
        {open.marginAgreementModal && (
          <MarginAgreementModal
            disabled={viewOnly}
            accountData={account}
            open={open.marginAgreementModal}
            onClose={handleCloseModal}
          />
        )}
        {open.marginDisclosureModal && (
          <MarginDisclosureModal
            disabled={viewOnly}
            open={open.marginDisclosureModal}
            close={handleCloseModal}
            tradingData={account}
          />
        )}
      </div>
    </FormBase>
  );
}
